<div class="gb-dialog-header filter-items-dialog-header">
  <h1>{{ 'PRESENTER.ITEM_TABLE_TOOLS.FILTER_ITEMS.TITLE' | translate }}</h1>
</div>

<div class="items-table gb-infinite-scroll-container">
  <gb-table-grid
    [enableSelect]="true"
    [selectedItems]="selectedItems()"
    [tableData$]="tableData$"
    [displayedColumns$]="getDisplayedColumns$(itemType)"
    [loaded$]="loaded$"
    [totalItemCount]="count$ | async"
    (selectedItemsChange)="onSelectedItemsChange($event)"
    (scrolled)="loadMoreItems()"
    [showTopPadding]="false"
    [dataView$]="tableView$"
  ></gb-table-grid>
</div>

<div class="filter-items-dialog-footer">
  <div class="items-selected-label">
    <span>{{ hiddenItemCount() }}</span>
    <span
      [translate]="
        hiddenItemCount() === 1 ? 'PRESENTER.ITEM_TABLE_TOOLS.ITEM_HIDDEN' : 'PRESENTER.ITEM_TABLE_TOOLS.ITEMS_HIDDEN'
      "
    >
    </span>
  </div>
  <div class="actions">
    <button mat-stroked-button type="button" (click)="cancel()">
      {{ 'CANCEL' | translate }}
    </button>
    <button mat-flat-button type="button" (click)="apply()">
      {{ 'APPLY' | translate }}
    </button>
  </div>
</div>

<ng-template #itemType let-data>
  <gb-item-type-chip [item]="data.item"></gb-item-type-chip>
</ng-template>
